// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__hhr1U","MainPadding":"Spinner_MainPadding__bq2oe","Orange":"Spinner_Orange__f5x-U","Gray":"Spinner_Gray__rI8nC"};